import styled from 'styled-components';
import { Icon } from '@usealloy/component-library';

const StyledIcon = styled(Icon)`
  color: inherit;
  margin-right: 10px;
  margin-left: -2px;
`;

const ExternalLinkIcon = styled(Icon)`
  opacity: 0;
  transition: opacity 0.2s ease-in-out;

  /* Show on hover of the parent DropdownMenu.Item */
  [data-dd-action-name="alloydd-sidebar-nav-resources-menu-option-alloy-lab"]:hover & {
    opacity: 1;
  }
`;

const HelpMenuItemContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 12rem;
`;

const HelpMenuTitle = styled.span`
  font-size: var(--cl-font-size-3);
  font-weight: 600;
  color: var(--cl-gray-1100);
  text-transform: unset;
  text-decoration: none;
  line-height: var(--cl-line-height-2);

  &:hover {
    text-decoration: none;
  }
`;

const HelpMenuDescription = styled.span`
  font-size: var(--cl-font-size-2);
  line-height: var(--cl-line-height-2);
  font-weight: 400;
  color: var(--cl-gray-1100);
`;


export {
  StyledIcon,
  ExternalLinkIcon,
  HelpMenuItemContent,
  HelpMenuTitle,
  HelpMenuDescription,
};

